import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "solojack"
  }, [_c('div', {
    staticClass: "solojack-bg",
    style: {
      background: `url(${require(`@images/${_vm.theme}/inset-bg.jpg`)}) center/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "solojack-main"
  }, [_c('div', {
    staticClass: "solojack-title"
  }, [_vm._v(" SoloJack "), _c('div', {
    staticClass: "btn-draw",
    on: {
      "click": _vm.setPopDrawHistoryShow
    }
  }, [_vm._v("Draw History")])]), _c('div', {
    staticClass: "solojack-cur"
  }, [_c('div', {
    staticClass: "solojack-cur__title"
  }, [_vm._v("Current Prize Pool")]), _c('div', {
    staticClass: "solojack-cur__num"
  }, [_vm.luckyInfo ? [_c('i', {
    class: !_vm.luckyInfo.icon && 'empty'
  }, [_vm.luckyInfo.prize.total > 0 ? [_c('img', {
    attrs: {
      "src": _vm.luckyInfo.icon,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.luckyInfo.prize.value) + "/"), _c('span', [_vm._v(_vm._s(_vm.luckyInfo.prize.total))])] : [_vm._v("0/"), _c('span', [_vm._v("0")])]], 2)] : _vm._e()], 2)]), _c('div', {
    staticClass: "solojack-progress"
  }, [_vm._m(0), _c('div', {
    staticClass: "solojack-progress-main"
  }, [_vm.luckyInfo ? _c('div', {
    staticClass: "bar",
    style: {
      width: _vm.luckyInfo.prize.value / _vm.luckyInfo.prize.total * 100 + '%'
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "solojack-intro"
  }, [_c('div', {
    staticClass: "solojack-intro__num"
  }, [_vm.roundStatus <= 0 ? _c('span', {
    staticClass: "nostarted"
  }, [_vm._v("Not started")]) : _vm.roundStatus >= 4 ? _c('span', {
    staticClass: "end"
  }, [_vm._v("Ended")]) : [_vm._v(" Round #" + _vm._s(_vm.luckyInfo ? _vm.luckyInfo.round.round_no : "--") + " "), _vm.roundStatus == 2 || _vm.roundStatus == 3 ? _c('span', {
    staticClass: "lottery"
  }, [_vm._v(", Drawing in progress...")]) : _vm._e()]], 2), _c('div', {
    staticClass: "solojack-intro__info"
  }, [_c('p', {
    attrs: {
      "data-text": "1."
    }
  }, [_vm._v(" The draw will be held immediately after all "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.luckyInfo ? _vm.formatter.fmt_pre(_vm.luckyInfo.round_duration) : "--"))]), _vm._v(" numbers are purchased for each round. ")]), _c('p', {
    attrs: {
      "data-text": "2."
    }
  }, [_vm._v("The winning numbers are generated randomly.")])])]), _c('div', {
    staticClass: "solojack-tab"
  }, [_c('div', {
    staticClass: "solojack-tab-item",
    class: !_vm.selectTab && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTab();
      }
    }
  }, [_vm._v("Purchase Activity")]), _c('div', {
    staticClass: "solojack-tab-item",
    class: _vm.selectTab && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTab(true);
      }
    }
  }, [_vm._v("My Lucky Number")])]), !_vm.selectTab ? _c('div', {
    staticClass: "solojack-list"
  }, [_vm.activityFeedsList ? [_vm.activityFeedsList.length > 0 ? _vm._l(_vm.activityFeedsList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "solojack-item"
    }, [_c('div', {
      staticClass: "solojack-item__icon"
    }, [_c('m-head', {
      attrs: {
        "name": item.bet_user,
        "bgColor": item.bet_user.head_color || '',
        "size": "28"
      }
    })], 1), _c('div', {
      staticClass: "solojack-item__name"
    }, [_vm._v(_vm._s(item.bet_user.firstname) + " " + _vm._s(item.bet_user.lastname))]), _c('div', {
      staticClass: "solojack-item__num"
    }, [_c('span', [_vm._v(_vm._s(item.buy_count))]), _vm._v(" Numbers ")])]);
  }) : [_c('div', {
    staticClass: "solojack__empty"
  }, [_vm._v("There's nothing here")])]] : _vm._e()], 2) : _vm._e(), _vm.selectTab ? _c('div', {
    staticClass: "solojack-nums"
  }, [_vm.myNumberList ? [_vm.myNumberList.length > 0 ? _vm._l(_vm.myNumberList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "solojack-nums-item"
    }, [_c('span', [_vm._v(_vm._s(_vm.padStartFn(item.number)))])]);
  }) : [_c('div', {
    staticClass: "solojack__empty"
  }, [_vm._v("There's nothing here")])]] : _vm.activityFeedsListPage.loading ? _c('div', {
    staticClass: "solojack__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })]) : _vm._e()], 2) : _vm._e(), _vm.selectTab && _vm.myNumberListPage.total > _vm.myNumberListPage.limit ? _c('div', {
    staticClass: "solojack-page"
  }, [_c('m-page', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.myNumberListPage.total,
      "page-size": _vm.myNumberListPage.limit,
      "page": _vm.myNumberListPage.page,
      "on-page-change": _vm.onMyNumberChange
    }
  })], 1) : _vm._e()]), _vm.roundStatus == 1 ? _c('div', {
    staticClass: "solojack-btns"
  }, [_c('div', {
    staticClass: "btn-get",
    on: {
      "click": _vm.onShowGetLucky
    }
  }, [_vm._v("Get Lucky Number")])]) : _vm._e(), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1), _c('pop-dialog', {
    attrs: {
      "show": _vm.popGetLuckyNumberShow,
      "isLoc": "bottom",
      "width": "100%",
      "height": "auto"
    },
    on: {
      "update:show": function ($event) {
        _vm.popGetLuckyNumberShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popGetLuckyNumber"
  }, [_c('div', {
    staticClass: "popGetLuckyNumber-main"
  }, [_c('div', {
    staticClass: "popGetLuckyNumber__title"
  }, [_vm._v("Get Lucky Number")]), _c('div', {
    staticClass: "popGetLuckyNumber-price"
  }, [_c('div', {
    staticClass: "popGetLuckyNumber-price__main"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/icon-diamond.png`),
      "alt": ""
    }
  }), _c('span', {
    class: _vm.isDiamondInsufficient && 'disable'
  }, [_vm._v(_vm._s(_vm.formatter.fmt_pre(_vm.luckyInfo.user.info.diamond)))]), _c('i', {
    staticClass: "icon-add",
    on: {
      "click": () => _vm.$router.push('/luckyBoxNew')
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-close"
    }
  })], 1), _c('div', {
    staticClass: "popGetLuckyNumber-price-info",
    on: {
      "click": () => _vm.popGetLuckyNumberInfoShow = true
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-quest"
    }
  })], 1)])]), _c('div', {
    staticClass: "popGetLuckyNumber__info"
  }, [_vm._v("1 Number = " + _vm._s(_vm.luckyInfo ? _vm.luckyInfo.price : "--") + " "), _c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/icon-diamond.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popGetLuckyNumber-pick"
  }, [_c('div', {
    staticClass: "popGetLuckyNumber-nums"
  }, [_vm._l([1, 5, 10], function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "popGetLuckyNumber-nums-item",
      class: [_vm.selectCount === item && 'active', _vm.leftLuckyNumberNum < item && 'disable'],
      on: {
        "click": function ($event) {
          return _vm.onSelectCount(item);
        }
      }
    }, [_vm._v("Random " + _vm._s(item))]);
  }), !_vm.isDiamondInsufficient ? _c('div', {
    staticClass: "popGetLuckyNumber-nums-btns"
  }, [_c('div', {
    staticClass: "btn-refresh",
    on: {
      "click": function ($event) {
        return _vm.onRefresh(false);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefreshLoading,
      "name": "icon-refresh"
    }
  })], 1)]) : _vm._e()], 2), _c('div', {
    staticClass: "popGetLuckyNumber-codes"
  }, [!_vm.isDiamondInsufficient ? [_vm.buyLuckyNumberList ? _vm._l(_vm.buyLuckyNumberList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "popGetLuckyNumber-codes-item"
    }, [_vm._v(_vm._s(_vm.padStartFn(item)))]);
  }) : [_c('div', {
    staticClass: "btn-loading"
  })]] : _vm._e()], 2), _vm.luckyNumberError ? _c('div', {
    staticClass: "popGetLuckyNumber-error"
  }, [_vm._v(_vm._s(_vm.luckyNumberError))]) : _vm._e()]), _c('div', {
    staticClass: "popGetLuckyNumber-btns"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.buyLuckyNumberList,
      expression: "buyLuckyNumberList"
    }],
    staticClass: "btn-confirm",
    on: {
      "click": _vm.buyLuckyBoxNumber
    }
  }, [!_vm.isBtnBuyLoading ? [_vm._v("Confirm")] : _c('div', {
    staticClass: "btn-loading"
  })], 2)])])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popDrawHistoryShow,
      "isLoc": "bottom",
      "width": "100%",
      "height": "auto"
    },
    on: {
      "update:show": function ($event) {
        _vm.popDrawHistoryShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popDraw"
  }, [_c('div', {
    staticClass: "popDraw-main"
  }, [_c('div', {
    staticClass: "popDraw__title"
  }, [_vm._v("Draw History")]), _c('div', {
    staticClass: "popDraw-tab"
  }, [_c('div', {
    staticClass: "popDraw-tab-item",
    class: !_vm.isDrawHistoryTabSelect && 'active',
    on: {
      "click": function ($event) {
        return _vm.getDrawHistorySelect(0);
      }
    }
  }, [_vm._v("Draw History")]), _c('div', {
    staticClass: "popDraw-tab-item",
    class: _vm.isDrawHistoryTabSelect && 'active',
    on: {
      "click": function ($event) {
        return _vm.getDrawHistorySelect(1);
      }
    }
  }, [_vm._v("My Records")])]), _c('div', {
    staticClass: "popDraw-list"
  }, [_c('div', {
    staticClass: "popDraw-head"
  }, [_c('span', {
    staticClass: "round"
  }, [_vm._v("Round")]), _c('span', {
    staticClass: "user"
  }, [_vm._v("Winning User")]), _c('span', [_vm._v("Winning Numbers")])]), _vm.drawHistoriesList ? [_vm.drawHistoriesList.length > 0 ? _vm._l(_vm.drawHistoriesList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "popDraw-item"
    }, [_c('div', {
      staticClass: "popDraw-item-form"
    }, [_c('div', {
      staticClass: "popDraw-item__code"
    }, [_vm._v("#" + _vm._s(item.round_no))]), _c('div', {
      staticClass: "popDraw-item__user"
    }, [_c('div', {
      staticClass: "popDraw-item__icon"
    }, [_c('m-head', {
      attrs: {
        "name": item.winning_user,
        "bgColor": item.winning_user.head_color || '',
        "size": "24",
        "fontSize": "13"
      }
    })], 1), _c('div', {
      staticClass: "popDraw-item__name"
    }, [_vm._v(_vm._s(item.winning_user.firstname) + " " + _vm._s(item.winning_user.lastname))])]), _c('div', {
      staticClass: "popDraw-item__num"
    }, [_vm._v(" " + _vm._s(_vm.padStartFn(item.winning_number)) + " ")])])]);
  }) : [_c('div', {
    staticClass: "popDraw__empty"
  }, [_vm._v("There's nothing here")])]] : [_c('div', {
    staticClass: "popDraw__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })])]], 2), _vm.drawHistoriesListPage.total > _vm.drawHistoriesListPage.limit ? _c('div', {
    staticClass: "popDraw-page"
  }, [_c('m-page', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.drawHistoriesListPage.total,
      "page-size": _vm.drawHistoriesListPage.limit,
      "page": _vm.drawHistoriesListPage.page,
      "on-page-change": _vm.onPopDrawPageChange
    }
  })], 1) : _vm._e()])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popLuckyResultShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popLuckyResultShow = $event;
      }
    }
  }, [_vm.winnerInfo ? _c('div', {
    staticClass: "popLuckyResult"
  }, [_c('div', {
    staticClass: "popLuckyResult-main"
  }, [_c('div', {
    staticClass: "popLuckyResult__icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/activity-top.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popLuckyResult__sub"
  }, [_vm._v("The draw has been announced.")]), _c('div', {
    staticClass: "popLuckyResult__round"
  }, [_vm._v("Round #" + _vm._s(_vm.winnerInfo.round_no))]), _c('div', {
    staticClass: "popLuckyResult-winner"
  }, [_c('div', {
    staticClass: "popLuckyResult-winner-num"
  }, [_vm._v(" " + _vm._s(_vm.padStartFn(_vm.winnerInfo.winning_item_id)) + " "), _c('span', [_vm._v("Winning Numbers")])]), _c('div', {
    staticClass: "popLuckyResult-winner-user"
  }, [_c('div', {
    staticClass: "popLuckyResult-winner-user__value"
  }, [_c('m-head', {
    attrs: {
      "name": _vm.winnerInfo.winners[0],
      "bgColor": _vm.winnerInfo.winners[0].head_color || '',
      "fontSize": "12",
      "size": 20
    }
  }), _c('span', [_vm._v(_vm._s(_vm.winnerInfo.winners[0].firstname) + " " + _vm._s(_vm.winnerInfo.winners[0].lastname))])], 1)]), _c('div', {
    staticClass: "popLuckyResult-btns"
  }, [_c('div', {
    staticClass: "btn-detail",
    on: {
      "click": _vm.onLuckyResultDetail
    }
  }, [_vm._v("Detail")])])])])]) : _vm._e()]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popGetLuckyNumberInfoShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGetLuckyNumberInfoShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popGetLuckyNumberInfo"
  }, [_c('div', {
    staticClass: "popGetLuckyNumberInfo__icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/icon-diamond.png`),
      "alt": ""
    }
  }), _c('span', [_vm._v("Diamond")])]), _c('div', {
    staticClass: "popGetLuckyNumberInfo__info"
  }, [_c('p', {
    attrs: {
      "data-text": "1."
    }
  }, [_vm._v("Diamond can participate in the Super Prize and have a chance to win the grand prize.")]), _c('p', {
    attrs: {
      "data-text": "2."
    }
  }, [_vm._v("Buying boxes can earn more Diamonds.")])]), _c('div', {
    staticClass: "popGetLuckyNumberInfo-btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/luckyBoxNew');
      }
    }
  }, [_vm._v("Go")])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popNewRoundLiveShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popNewRoundLiveShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popNewRoundLive"
  }, [_c('div', {
    staticClass: "popNewRoundLive__title"
  }, [_vm._v("New Round Live!")]), _c('div', {
    staticClass: "popNewRoundLive__sub"
  }, [_vm._v("Place your bets now—don’t miss out!")]), _c('div', {
    staticClass: "popNewRoundLive-btn",
    on: {
      "click": _vm.onJoinRound
    }
  }, [_vm._v("Join Round")])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popHangUpPromptShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popHangUpPromptShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popNewRoundLive"
  }, [_c('div', {
    staticClass: "popNewRoundLive__title"
  }, [_vm._v("Remind")]), _c('div', {
    staticClass: "popNewRoundLive__sub"
  }, [_vm._v("Still hesitating? Trust yourself ! "), _c('br'), _vm._v("Place your bet now and win big!")]), _c('div', {
    staticClass: "popNewRoundLive-btn",
    on: {
      "click": _vm.onHangUpPromptGetLuckyNumber
    }
  }, [_vm._v("Get Lucky Number")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "solojack-progress__info"
  }, [_c('i', [_vm._v("0 TON")]), _vm._v(" "), _c('i', [_vm._v("Draw")])]);
}];
export { render, staticRenderFns };